export const shDateFormat = (date) => {
    if (!date) return date;

    let idx = date.indexOf('T');
    if (idx !== -1) {
        date = date.substr(0, idx);
    }

    const dateSplit = date.split('-');

    return dateSplit[2] + "." + dateSplit[1] + "." + dateSplit[0];
}
